export default async function downloadFile(response, fallbackFilename) {
  try {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement('a');
    a.href = url;

    let filename = fallbackFilename;
    const disposition = response.headers['content-disposition'];

    if (disposition && disposition.indexOf('attachment') !== -1) {
      const filenameMatch = disposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch[1]) {
        // eslint-disable-next-line prefer-destructuring
        filename = filenameMatch[1];
      }
    }

    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
    throw error;
  }
}
